// Single source of truth for schema-lookup tool bounds. The partner API validates against
// these and the partner dashboard authors against them — edit here, not at either call site.
/** Most records a single schema lookup may return. */
export const SCHEMA_LOOKUP_MAX_LIMIT = 25;
/** Records a new schema lookup returns until the partner changes it. */
export const SCHEMA_LOOKUP_DEFAULT_LIMIT = 10;
/** Most fixed equality filters a schema lookup may pin. */
export const SCHEMA_LOOKUP_MAX_FILTERS = 10;
//# sourceMappingURL=tool-lookup.js.map